import type { Scale } from "../scale/Scale"

export type ScaleMap = Record<string, Scale>
